export default "__VITE_ASSET__DfP9Cf4O__";